import { ContactUs } from '@/layout/Contact-Us';
import { Footer } from '@/layout/Footer';
import { Nav } from '@/layout/Nav';

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <main>
            <Nav />
            {children}
            <ContactUs />
            <Footer />
        </main>
    );
};
